import React, { useEffect } from "react"
import { Router } from "@reach/router"
import ProgressWrapper from "./ProgressWrapper"
import { getCurrentStep } from "./helpers/steps"
import SEO from "../seo"
import { getUriParameterByName } from "../../helpers"
import { trackSegmentEvent } from "../../helpers/segment"
import { trackAmplitude } from "../../helpers/amplitude"
import { trackCustomFB } from "../../helpers/fbPixel"
import Step from "./Step"

// setup all amplify modules
import Amplify from "@aws-amplify/core"
import API from "@aws-amplify/api" // eslint-disable-line
import awsconfig from "../../aws-exports"
Amplify.configure(awsconfig)

const QuestionnaireApp = ({ basepath, type, url }) => {
  useEffect(() => {
    trackSegmentEvent("track", "Questionnaire open")
    trackAmplitude("Questionnaire open")
    trackCustomFB("Open questionnaire")
  }, [])

  const retake = getUriParameterByName("retake", url) === "true"
  const baseProps = { basepath, retake, type }

  return (
    <div id="questionnaire-modal-root">
      <SEO title="Take our brand discovery survey" />
      <ProgressWrapper currentStep={getCurrentStep(basepath)}>
        <Router {...baseProps}>
          <Step {...baseProps} path="0" step={0} default />
          <Step {...baseProps} path="1" step={1} />
          <Step {...baseProps} path="2" step={2} />
          <Step {...baseProps} path="3" step={3} />
          <Step {...baseProps} path="4" step={4} />
          <Step {...baseProps} path="5" step={5} />
          <Step {...baseProps} path="6" step={6} />
          <Step {...baseProps} path="7" step={7} />
          <Step {...baseProps} path="8" step={8} />
          <Step {...baseProps} path="9" step={9} />
          <Step {...baseProps} path="10" step={10} />
          <Step {...baseProps} path="11" step={11} />
          <Step {...baseProps} path="12" step={12} />
          <Step {...baseProps} path="13" step={13} />
          <Step {...baseProps} path="14" step={14} />
          <Step {...baseProps} path="15" step={15} />
          <Step {...baseProps} path="16" step={16} />
        </Router>
      </ProgressWrapper>
    </div>
  )
}

export default QuestionnaireApp
